export function getCookieValue(a: string): string {
    let b: RegExpMatchArray | null = document.cookie.match('(^|;)\\s*' + a + '\\s*=\\s*([^;]+)');
    if (b) {
        let match: string | undefined = b.pop();

        return match !== undefined ? match : '';
    } else {
        return '';
    }
}
function setCookie(name: string, value: string, options: any) {
    options = {
        path: '/',
        ...options
    };

    if (options.expires instanceof Date) {
        options.expires = options.expires.toUTCString();
    }

    let updatedCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);

    for (let optionKey in options) {
        updatedCookie += '; ' + optionKey;
        let optionValue = options[optionKey];
        if (optionValue !== true) {
            updatedCookie += '=' + optionValue;
        }
    }

    document.cookie = updatedCookie;
}
export function deleteCookie(name: string) {
    setCookie(name, '', {
        'max-age': -1
    });
}
